<div class="wrapper">
    <div class="container-header">
        <!-- <dop-header [externalLinks]="externalLinks" [landingPageUrl]="landingPageUrl">
        </dop-header> -->

        <!-- <sdh-header
            [appName]="'Study Design Hub'"
            [landingPageUrl]="landingPageUrl"
            [avatarInitials]="avatarInitials"
            [externalLinks]="externalLinks"
            [additionalMenuLinks]="additionalMenuLinks"
            [shadowSet]="'default'"
            (logoTriggered)="onLogoTriggered()"
            (logoutTriggered)="logout()"
        ></sdh-header> -->
        <app-common-header [title]="title" [subTitle]="subTitle" [scenarioTitle]="scenarioTitle"
            [elementName]="elementName" [showShareButton]="showShareButton" [collaboratorCount]="collaboratorCount"
            [avatarInitials]="avatarInitials" [user_role]="user_role" [isSOA]="isSOA"></app-common-header>
    </div>
    <div class="container-content bg-warm-blue-gradient-bottom-right">
        <div class="container-main">
            <div class="content-block" [class.soa-content-block]="isSOA" (scroll)="onScrollChange()">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>